import { ROOT_GROUP_FIELD_KEY } from '../constants';
const getSettingsMeta = state => state.themeSettingsMeta;
export const getHasBufferedChanges = state => getSettingsMeta(state).hasBufferedChanges;
export const getPublishRequestStatus = state => getSettingsMeta(state).publishRequestStatus;
export const getSaveRequestStatus = state => getSettingsMeta(state).saveRequestStatus;
export const getActiveFieldKey = state => {
  const activeFieldKey = getSettingsMeta(state).activeFieldKey || ROOT_GROUP_FIELD_KEY;
  return activeFieldKey.length ? activeFieldKey : null;
};
export const getUpdatedThemeFieldKeys = state => getSettingsMeta(state).updatedSettings || [];